import { render, staticRenderFns } from "./SubEmpresaGestaoElegibilidadePY.vue?vue&type=template&id=bfb66750&lang=pug"
import script from "./SubEmpresaGestaoElegibilidadePY.vue?vue&type=script&lang=js"
export * from "./SubEmpresaGestaoElegibilidadePY.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaGestaoElegibilidadePY.vue?vue&type=style&index=0&id=bfb66750&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports